import React from "react";
import "./index.css";
import { useCons } from "../context/ConsContext";
import herocar from "../assets/herocar.png";
import carsvg from "../assets/carsvg.svg";

const Hero = ({ dataButton, dataClass }) => {
  const { buttonData } = useCons();

  return (
    <div className={dataClass ? dataClass + " fullH" : "fullH"}>
      <div className="container-sm flex flexCol alignCenter">
        <div className="flex flexRow alignCenter flexWrap">
          <div className="textCol">
            <h1 className="relative">
              Leave your car in <span>our hands</span>
            </h1>
            <p className="relative">
              A trusted name specialized in repair, maintenance and care
              services for your vehicle serving all of Los Angeles, including
              San Fernando Valley.
            </p>
            <button className="btn" onClick={() => buttonData(true)}>
              Free Estimate
            </button>
          </div>
          <img src={herocar} alt="Hero Car" className="heroCar" />
        </div>
        <img src={carsvg} className="carsvg" alt="Car SVG" />
      </div>
    </div>
  );
};

export default Hero;
